jQuery(document).ready(function($) {
    init_workday();

    if (is_dev) {
        // setTimeout(() => {
        //     const sender = $('tr[data-id="9"]').find('[type="checkbox"]:first')[0];
        //     mark_device_done(85, 9, sender);
        // }, 2000);
        // view_device(24);
    }
});

function init_workday() {
    const $ = jQuery.noConflict();
    activate_datepicker();
    if ($('.workday-wrapper').length === 0) {
        return;
    }
    $('body').attr('data-prevent-location-reload', true);
    const filtersForm = $('.filters-header');

    let filterWaiter = null;
    let visitsAjax = null;

    $('[data-employee-selector]').employeeSelector();

    filtersForm.find(':input').change(function() {
        if (filterWaiter !== null) {
            clearTimeout(filterWaiter);
        }
        filterWaiter = setTimeout(function() {
            const filterData = $('.filters-header').serializeJSON();
            if (filterData.employee_id !== undefined) {
                retrieve_visits_for(filterData.employee_id, filterData.date);
                setCookie('visitsFilters', filterData, 1);
            }
        }, 500);
    });

    const setFilters = getCookie('visitsFilters', null);
    if (setFilters !== null) {
        for(let key in setFilters) {
            if (setFilters[key] !== undefined) {
                filtersForm.find('input[name="' + key + '"]').val(setFilters[key]).trigger('change');
            }
        }
    }


    function activate_datepicker() {
        const input = $('.filter input.hasDatepicker[name="date"]');
        const onMonthYearChange = function(year, month) {
            const filterData = $('.filters-header').serializeJSON();
            if (filterData.employee_id !== undefined) {
                const date = '01-' + (leadingZero(month, 2)) + '-' + year;
                retrieve_visits_for(filterData.employee_id, date, true, function(dates) {
                    const table = $('.ui-datepicker-calendar');
                    if (table.length === 0) {
                        return;
                    }
                    $.each(dates, function(index, date) {
                        const y = parseInt(date.split('-')[0]);
                        const m = parseInt(date.split('-')[1]);
                        const d = parseInt(date.split('-')[2]);


                        const tds = table.find('td[data-month="' + (m - 1) + '"][data-year="' + y + '"]');
                        tds.each(function() {
                            const td = $(this);
                            const contents = parseInt(td.text());

                            if (contents === d) {
                                td.addClass('highlight');
                            }
                        });
                    });
                });
            }
        };
        input.datepicker( "option", "onChangeMonthYear", onMonthYearChange);
        input.datepicker( "option", "beforeShow", function() {


            const month = parseInt(input.val().split('-')[1]);
            const year = parseInt(input.val().split('-')[2]);

            onMonthYearChange(year, month);
        });




        // input.datepicker( "option", "beforeShowDay", function(date) {
        //     console.log('a');
        //     const className = Math.floor(Math.random() * 2) === 1 ? 'highlight' : null;
        //     return [true, className, ''];
        // } );

    }


    /**
     * Retrieve all visits for an employee for a certain date
     *
     * @param employee_id
     * @param date
     * @param retrieveCount
     * @param callback
     */
    function retrieve_visits_for(employee_id, date, retrieveCount = false, callback = function() {}) {
        if (visitsAjax !== null) {
            visitsAjax.abort();
        }
        $('body').isLoading();
        visitsAjax = $.ajax({
            url: '/workday/getData/' + employee_id,
            data: {date, retrieveCount},
        }).always(function() {
            $('body').doneLoading();
        }).done(function(data) {
            if (retrieveCount === true) {
                callback(data);
            } else {
                writeout_visits(data);

                update_print_buttons(data);
            }
        });
    }

    /**
     * Write out all in visits on the screen
     *
     * @param visits
     */
    function writeout_visits(visits) {
        const wrapper = $('.list-wrapper');
        wrapper.find('.list-item:not(:first)').remove();

        for(let i in visits) {
            const visit = visits[i];
            const first = wrapper.find('.list-item:first');
            const li = first.clone(true, true);
            wrapper.find('.list-item:last').after(li);

            li.show();

            writeout_single_visit(li, visit);

            if (parseInt(i) === 0) {
                li.find('.expandable-toggle-wrapper').addClass('open');
                li.find('.expandable-toggle-wrapper').next().addClass('open');
            }
        }
    }

    /**
     * Add a general note about a visit
     *
     * @param visit
     */
    function add_general_note(visit) {

    }

    /**
     * Change what happens when you click the print button
     *
     * @param visits
     */
    function update_print_buttons(visits) {
        const printButton = filtersForm.find('a.print-button');
        if (visits.length === 0) {
            printButton.hide();
        } else {
            printButton.show();
            let printOptions = [];

            $.each(visits, (index, visit) => {
                if (visit.order.printOptions && visit.order.printOptions.length > 0) {
                    const optionsClone = JSON.parse(JSON.stringify(Object.values(visit.order.printOptions)));
                    $.each(optionsClone, (index, printOption) => {
                        let add = true;
                        $.each(printOptions, (index, currentPrintOption) => {
                            if (printOption.title === currentPrintOption.title) {
                                add = false;
                            }
                        });
                        if (add) {
                            printOptions.push(printOption);
                        }
                    });
                }
            });

            printOptions = JSON.parse(JSON.stringify(printOptions));
            const ids = Object.values(visits).map(visit => visit.order_id);
            $.each(printOptions, (index, printOption) => {
                const layout = printOption.action.split('/print/')[1].split('/')[0];
                printOption.title = 'Verzameling: ' + printOption.title;
                printOption.action = 'print_collection(' + layout + ', ' + JSON.stringify(ids) + ')'
            });

            printButton.unbind('click').dropdownOptions(printOptions);
        }
    }
}


/**
 * Write out a single visit on the screen
 *
 * @param container
 * @param visit
 */
function writeout_single_visit(container, visit) {
    const $ = jQuery.noConflict();
    container.find('input.order_id').val(visit.order_id);

    const date = new Date();
    date.setFullYear(visit.date.split('-')[0]);
    date.setMonth(parseInt(visit.date.split('-')[1]) - 1);
    date.setDate(visit.date.split('-')[2]);
    const weekday = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'][date.getDay()];

    container.find('.date').html(weekday + ' ' + leadingZero(date.getDate()) + '-' + leadingZero((date.getMonth() + 1)) + '-' + date.getFullYear());
    const start_time = visit.start_time.split(':')[0] + ':' + visit.start_time.split(':')[1];
    container.find('.start-time').html(start_time);
    const end_time = visit.end_time.split(':')[0] + ':' + visit.end_time.split(':')[1];
    container.find('.end-time').html(end_time);

    const customerName = visit.order.client.messageName === undefined ? visit.order.client.name : visit.order.client.messageName;
    container.find('.title .client-name').html(customerName);

    const address = container.find('.address-wrapper');
    address.find('.maps-route-url').attr('href', visit.order.mapsRouteUrl);
    address.find('.client-address').html(visit.order.address);
    address.find('.client-address-postal-code').html(visit.order.postal_code);
    address.find('.client-address-city').html(visit.order.city);

    const notesButton = container.find('.notes-wrapper a');
    notesButton.attr('onclick', visit.order.viewNotesAction);
    notesButton.find('.notes-count').html(visit.order.numberOfNotes);

    const actionDetails = container.find('.show-if-order-has-actions');
    const hasActions = visit.hasActions;
    const hasContract = visit.order.contract !== null;
    actionDetails.toggle(hasActions);
    if (hasContract) {
        container.find('.title .client-address-city').html(visit.order.contract.city);

        container.find('.contract-description').html(visit.order.contract.name);
    } else {
        container.find('.contract-description').remove();
    }
    if (hasActions) {
        container.find('.show-if-order-has-devices').toggle(visit.order.deviceCount > 0);
        if (visit.order.deviceCount > 0) {
            container.find('.device-count').html(visit.order.deviceCount);
            container.find('.if-device-count-1').toggle(parseInt(visit.order.deviceCount) === 1);
            container.find('.if-device-count-not-1').toggle(parseInt(visit.order.deviceCount) !== 1);
        }
        container.find('.show-if-order-has-other-actions').toggle(visit.order.hasOtherActions);
        container.find('.has-both-kind-of-actions').toggle(visit.order.hasOtherActions && visit.order.deviceCount > 0);
    } else {
        const tabsWrapper = container.find('.tabs-wrapper');
        actionDetails.remove();
        tabsWrapper.attr('data-tabs', tabsWrapper.find('.tab').length);
        tabsWrapper.attr('data-active-tab', tabsWrapper.find('.tab:first').index() + 1);
    }

    container.find('.scrollable-table').each(function() {
        const table = $(this);
        const filterKey = get_unique_id('data-filters-key');
        table.attr('data-filters-key', filterKey);
        table.parent().find('[data-replaceme-filter]').attr('data-' + filterKey + '-filter', true).removeAttr('data-replaceme-filter');

        table.parents('.tab-content').on('showTab', function() {
            table.reloadThisElement();
        });

        setTimeout(function() {
            const tabsWrapper = table.parents('.tabs-wrapper');
            tabsWrapper.find('.tab-content:nth-child(' + tabsWrapper.attr('data-active-tab') + ')').find('table').reloadThisElement();
        }, 500);
    });

    container.find('input[name="order_id"]').val(visit.order.id);

    const options = [];

    const printOptions = visit.order.printOptions;
    if (printOptions && printOptions.length > 0) {
        options.push({
            title: 'Printen...',
            options: printOptions
        });
    }

    if (!visit.done) {
        options.push({
            title: 'Afronden',
            action: 'visit_done(' + visit.id + ')'
        });
    }

    options.push({
        title: 'Contactgegevens',
        action: visit.order.contact_id > 0 ? 'view_contact_options(' + visit.order.contact_id + ')' : 'view_company_contact_options(' + visit.order.company_id + ')'
    }, {
        title: 'Notitie toevoegen',
        action: visit.order.addNotesAction
    }, {
        title: 'Apparaat toevoegen',
        action: () => {
            const type = visit.order.contact_id > 0 ? 'contact' : 'company';
            const id = visit.order.contact_id > 0 ? visit.order.contact_id : visit.order.company_id;
            return add_device(type, id, (device) => {
                device = JSON.parse(device);
                place_device_action_on_order(visit.order.id, device.id);
                container.find('.scrollable-table.devices-table').reloadThisElement();
            });
        }
    });



    if (visit.order.viewAction) {
        options.push({
            title: 'Order bekijken',
            action: visit.order.viewAction
        });
        if (visit.order.contract && visit.order.contract.viewAction) {
            options.push({
                title: 'Contract bekijken',
                action: visit.order.contract.viewAction
            });
        }
    }


    container.find('.options-button-wrapper').dropdownOptions(options);
}

/**
 * Mark a device as being done
 *
 * @param sender
 * @param device_id
 */
function toggle_device_done(sender, device_id) {
    const $ = jQuery.noConflict();
    const order_id = $(sender).parents('.list-item').find('input.order_id').val();

    if ($(sender).is(':checked')) {
        mark_device_done(order_id, device_id, sender);
    } else {
        mark_device_not_done(order_id, device_id, sender);
    }
}

/**
 * Mark an action done
 *
 * @param sender
 * @param order_action_id
 */
function toggle_action_done(sender, order_action_id) {
    const $ = jQuery.noConflict();

    $.post('/workday/doneAction/' + order_action_id, {done: $(sender).is(':checked')});
}

/**
 * Open the screen where you tell the system what you did with the device
 * @param order_id
 * @param device_id
 * @returns {boolean}
 */
function mark_device_done(order_id, device_id, sender) {
    const $ = jQuery.noConflict();
    const checkbox = $(sender);


    $.squdeAjaxPopup({
        url: '/workday/' + order_id + '/devices/' + device_id + '/doneForm',
        onClose: function() {
            checkbox.removeAttr('checked');
        },
        onOpen: function (elm, popup) {
            const deviceSelector = elm.find('[data-device-selector]');
            if (parseInt(deviceSelector.attr('data-current-value')) > 0) {
                toggle_replace_device_wrapper(elm, deviceSelector, true);
            }

            const toggleDeviceDisableField = (action_id, leaveOpen = false) => {
                get_action(action_id).then((action) => {
                    let shouldSelectNewDevice = action.should_disable_device === 1;
                    if (leaveOpen && elm.find('.replace-device-wrapper').is(':visible')) {
                        shouldSelectNewDevice = true;
                    }
                    toggle_replace_device_wrapper(elm, deviceSelector, shouldSelectNewDevice);
                });
            };

            elm.find('input[name="action_ids\[\]"]').each(function() {
                const input = $(this);
                const value = input.val();
                if (parseInt(value) > 0) {
                    toggleDeviceDisableField(value, true);
                }
            });

            get_device(device_id)
                .then((device) => {
                    deviceSelector.deviceSelector(undefined, {
                        onOpen: (elm) => {
                            elm.find('#location_description').val(device.location_description);
                            elm.find('#walking_route_number').val(device.walking_route_number);
                        }
                    });
                });
            elm.find('.tag-input-action_ids').bind('changeTags', function(event, data, added, deleted) {
                elm.isLoading();
                const changed = added ? added : deleted;
                get_products({action_id: changed.id})
                    .then(function (products) {
                        const productsTags = elm.find('.tag-input-used_products');

                        if (!!deleted) {
                            const selectedProducts = productsTags.getTags().filter((v, i, a) => a.indexOf(v) === i).map((value) => parseInt(value));
                            products = products.filter((product) => selectedProducts.indexOf(product.id) >= 0 );
                        }

                        elm.doneLoading();

                        if (products.length > 0) {
                            let message = '<div>De volgende artikelen horen bij de actie <em>' + changed.name + '</em> en zullen worden ' + (added ? 'toegevoegd' : 'verwijderd') + ':</div>';
                            const ul = $('<ul></ul>');
                            $(products).each(function(index, product) {
                                ul.append('<li>' + product.count + 'x ' + product.name + '</li>');
                            });
                            ul.css({marginTop: 15});
                            message += (($('<div></div>')).html(ul)).html();

                            message = ($('<div style="font-size: 12px;"></div>')).html(message);

                            const okayText = added ? 'Artikelen toevoegen' : 'Artikelen verwijderen';
                            const cancelText = added ? 'Artikelen niet toevoegen' : 'Niet verwijderen';
                            elm.find('.products-headsup').confirmCallback(message, () => {
                                productsTags.setTags(products, !added);
                                elm.find('[type="submit"]').removeAttr('disabled');
                            }, () => {
                                elm.find('[type="submit"]').removeAttr('disabled');
                            }, okayText, cancelText);

                            elm.find('[type="submit"]').attr('disabled', 'disabled');
                        }
                    });

                if (!!added) {
                    toggleDeviceDisableField(added.id);
                }
            });

            elm.find('form').ajaxFormSubmit((data) => {
                $('body').doneLoading();
                popup.close();
                updateObject('device', device_id);
                squde_reload_for_flashes();
            }, (xhr, status, error) => {
                console.log(xhr,status,error);
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }, () => {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function toggle_replace_device_wrapper(elm, deviceSelector, toggle) {
    const $ = jQuery.noConflict();
    elm.find('.replace-device-wrapper').toggle(toggle);
    deviceSelector.unbind('change.productSelection');
    if (toggle) {
        deviceSelector.bind('change.initialProductSelection', function() {
            deviceSelector.unbind('change.initialProductSelection');
            deviceSelector.bind('change.productSelection', function() {
                get_device($(this).val())
                    .then((device) => {
                        if (device !== null && device.product_id > 0) {
                            const productsTags = elm.find('.tag-input-used_products');
                            const currentTags = productsTags.getTags().map((tagId) => {
                                return parseInt(tagId);
                            });
                            if (currentTags.indexOf(parseInt(device.product_id)) < 0) {
                                get_products({id: device.product_id})
                                    .then((products) => {
                                        productsTags.setTags(products, false);
                                    });
                            }
                        }
                    });
            });
        });
    }
}
function mark_device_not_done(order_id, device_id, sender) {
    custom_delete_with_confirmation('/inspections/' + order_id + '/' + device_id + '/delete', order_id, 'Weet u zeker dat u deze inspectie wilt resetten?', 'inspection', () => {
        squde_reload_for_flashes();
        updateObject('device', device_id);
    }, () => {
        if (sender) {
            sender.checked = true;
        }
    });
    return false;
}

/**
 * Mark a visit done
 *
 * @param visit_id
 */
function visit_done(visit_id) {
    const $ = jQuery.noConflict();
    const str = 'Weet u zeker dat u deze planning wilt afronden?<br />Wijzigen is hierna niet langer mogelijk.';
    confirm(str, () => {
        $.post('/workday/done/' + visit_id, (visit) => {
            squde_reload_for_flashes();
            if ($('form.filters-header').length > 0) {
                $('form.filters-header').find(':input:first').trigger('change');
            } else {
                $('.single-workday-item .scrollable-table').each(function() {
                    $(this).reloadThisElement();
                });
            }

            updateObject('order', visit.order_id);
        });
    });
    return false;
}

function view_workday_item(order_id) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/workday/' + order_id,
        onOpen: function (elm, popup) {
            const visit = elm.find('.list-item').getThisElementsData();
            writeout_single_visit(elm.find('.list-item'), visit);
            elm.find('.list-item').show();
        }
    });
    return false;
}


/**
 * Mark a product as being delivered
 *
 * @param sender
 * @param product_id
 */
function toggle_product_delivered(sender, product_id) {
    const $ = jQuery.noConflict();
    const order_id = $(sender).parents('.list-item').find('input.order_id').val();

    const delivered = $(sender).is(':checked');

    $.post({
        url: '/workday/' + order_id + '/products/' + product_id + '/markDelivered',
        data: {delivered},
        error: () => {
            sender[0].checked = !delivered;
        },
        success: (data) => {
            squde_flash('Wijziging opgeslagen');
        }
    });
}
